import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Spinner } from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { registerUser, apiError } from "../../store/actions";

//Import Icons
import FeatherIcon from "feather-icons-react";
//redux
import { useSelector, useDispatch } from "react-redux";

import AuthLayout from "../../components/authenticate/AuthLayout";

const RegisterCheck = (props) => {
  const dispatch = useDispatch();

  const { user, registrationError } = useSelector((state) => ({
    user: state.Account.user,
    registrationError: state.Account.registrationError,
    loading: state.Account.loading,
  }));

  // handleValidSubmit
  const handleValidSubmit = (values) => {
    dispatch(registerUser(values));
  };

  useEffect(() => {
    setStatus();
  }, []);
  


  const taskName = "DNSRecords";
  const token = window.location.href.split("account-verify/")[1];
  // console.log(token);
  async function setStatus(event) {
    // e.preventDefault()
    const response = await fetch(`${process.env.REACT_APP_DEFAULTPATH}changestatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
        taskName
      }),
    });
    const data = await response.json();
    console.log("data" , data)
    if(data.status){
      localStorage.setItem("registerStatus", true);
      window.location.href = "/account-verify-message";
    }
    else{
      localStorage.setItem("registerStatus", false);
      window.location.href = "/account-verify-message";
    }
    // window.location.href = "/account-verify-message";
    // if (data.status === "ok") {
    //   console.log("password change success");
    //   window.location.href = "/Login";
    // }
    // console.log(data.data);
    // window.location.href = "/Login";
  }


  return (
    <React.Fragment>
      <MetaTags>
        <title>Glogix - Signin-Success</title>
      </MetaTags>
      <AuthLayout>
        <div className="gx-auth-card">
          <div className="gx-auth-title mb-0">
            <Spinner className="mb-3" color="primary" />
            <h4>Verifying your account</h4>
            <p>Please wait a moment...</p>
          </div>
        </div>
      </AuthLayout>
    </React.Fragment>
  );
};

export default RegisterCheck;
